import { graphql } from "@opensea/graphql"

export const CreateCollectionOfferFlowTableRowFragment = graphql(`
  fragment CreateCollectionOfferFlowTableRow on Collection {
    imageUrl
    name
    chain {
      identifier
      offerCurrency {
        symbol
      }
      listingCurrency {
        symbol
      }
    }

    floorPrice {
      id
      pricePerItem {
        token {
          unit
          symbol
        }
      }
    }
    topOffer {
      id
      pricePerItem {
        token {
          unit
          symbol
        }
      }
    }

    fees {
      openseaFee {
        feeBasisPoints
      }
      totalCreatorFee {
        feeBasisPoints
      }
    }
  }
`)
